export const prepareRequestPayload = (formData) => {
  const { email, 'g-recaptcha-response': gRecaptchaResponse } = formData;

  return {
    email,
    'g-recaptcha-response': gRecaptchaResponse,
  };
};
